import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { EnregistrerSignature } from "src/app/parametrage/core/model/employee/enregistrer-signature";

@Component({
  selector: "app-upload-signature",
  templateUrl: "./upload-signature.component.html",
  styleUrls: ["./upload-signature.component.scss"],
})
export class UploadSignatureComponent implements OnInit {
  @Input() username;

  employee: Employee;

  form: FormGroup;

  public file: File;
  public signature: string | ArrayBuffer;
  public signatureContentType: String;

  enregistrerSignature: EnregistrerSignature = new EnregistrerSignature();

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _employeeService: EmployeeService,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      signature: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getEmployeeByUsername(this.username);
  }

  getEmployeeByUsername(username) {
    this._employeeService.getEmployeeByUsername(username).subscribe(
      (data) => {
        this.employee = data;
        this.enregistrerSignature.username = this.username;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeListener($event) {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    this.file = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.employee.signature = myReader.result.toString().split(",")[1];
      this.employee.signatureContentType = this.file.type;
    };
    myReader.readAsDataURL(this.file);
  }

  changeSignature(): void {
    this.readThis(this.form.value.signature);
  }

  save(): void {
    this.enregistrerSignature.signature = this.employee.signature;
    this.enregistrerSignature.signatureContentType =
      this.employee.signatureContentType;
    this._employeeService
      .enregistrerSignature(this.enregistrerSignature)
      .pipe(first())
      .subscribe(
        (data) => {
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
